var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.img)?_c('div',{staticClass:"banner row justify-center items-center image",on:{"click":function($event){_vm.$watchContent(_vm.item)}}},[_c('v-img',{key:_vm.img.url,attrs:{"item":_vm.item,"img":_vm.img}})],1):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-288fc97d","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/front/Banner.vue
// module id = 9W/f
// module chunks = 72